/** URL search-param key that selects the pre-filled account-claim signup flow. */
export const CLAIM_ACCOUNT_EMAIL_PARAM = 'claimAccountEmail';
